import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

const AlertInput = ({ name, setName }) => {
  return (
    <Form.Group>
      <Form.Label>Nombre de la Búsqueda</Form.Label>
      <InputGroup>
        <Form.Control
          type="text"
          placeholder="Alquileres de casas en Recoleta..."
          size="md"
          value={name}
          onChange={e => setName(e.target.value)}
        />
      </InputGroup>
    </Form.Group>
  );
};

AlertInput.propTypes = {
  name: PropTypes.string.isRequired,
  setName: PropTypes.func.isRequired
};

export default AlertInput;
